/**
 *    @author: Andrew Sheen
 *    @since:  2021-01-24
 *
 */

import { ViewportScroller } from '@angular/common';
import { Code, Confirm, Country } from 'src/refresh/service/constant';
import { Util } from 'src/refresh/service/Util';
import { IValidator } from '../_common/component/IValidator';
import { ParentInfo } from '../_common/data/input-data';
import { AboutTheParentsScreenComponent} from './about_the_parents_screen.component';
var show = console.log.bind( console );

const PREFIX = "parentScreen.";

export class AboutTheParentsScreenValidation extends IValidator {

       constructor(private component: AboutTheParentsScreenComponent , private menuID:number ) {
                   super();
                   this.viewportScroller = this.component.viewportScroller;
                   this.inputParent.copyFrom(this.component.parent);
                   this.parent  = this.component.parent;
       }

       private inputParent:ParentInfo = new ParentInfo();
       private parent:ParentInfo;

       private viewportScroller:ViewportScroller;

       private success: boolean;

       public validate(): boolean {

            this.success = true;

            this.parentTypeValidate();

            if ( this.component.isBirthParent || this.component.isSurrogate && this.component.parentIndex == 0  ) {
                 this.maritalStatusValidate();
            }
            
            if ( this.component.isBirthParent == true ) {
                 
                 this.pregnancyDurationValidate();

                 if ( this.component.data.subject.index <= 1 ) {  // first child only
                      this.previousBornValidate();
                 }
            }

            this.whenParenBornValidate();
            this.otherLastNameAtBirth();
            this.otherPreviousNameUsed();
            this.cityValidate();
            this.provinceValidate();
            this.countryValidate();

            if ( this.parent.placeOfBirth.country == Code.NotFound )
                 this.otherCountryValidate();

            return this.success;

       }

       private parentTypeValidate() {

               if ( Util.isEmpty(this.parent.parentType)  )  {
                     if (  !this.component.isCustodyOtherThanParent || this.parent.isGiveBirth==Confirm.YES )
                     this.focus('parenTitle','radio_parentTypeRadio_0' ).error_parentType = PREFIX + 'parent_title.error_empty_birthParent$';
               }
       }

       private maritalStatusValidate() {

               if ( !this.component.isCustodyOtherThanParent && 
                     this.component.parentIndex == 0 && 
                     Util.isEmpty(this.parent.maritalStatus) ) 
                     this.focus('maritalStatus','select_maritalStatusSelect').error_maritalStatus = PREFIX + 'maritalStatus.error_empty_birthParent$';
       }


       private pregnancyDurationValidate() {

               if ( Util.isEmptyNumber(this.parent.pregnancyDuration) ) {
                    if ( !this.component.isCustodyOtherThanParent )
                          this.focus('pregnancyInfo','input_pregnancyDuration').error_pregnancyDuration = PREFIX + 'pregnancy.error_empty';
               }
               else 
               if ( this.parent.pregnancyDuration < 15 ||
                    this.parent.pregnancyDuration > 45  ) 
                    this.focus('pregnancyInfo','input_pregnancyDuration').error_pregnancyDuration = PREFIX + 'pregnancy.error_invalid';
       }

       private previousBornValidate() {

               if ( Util.isEmpty(this.parent.isPreviousBirth) ) {
                    if ( !this.component.isCustodyOtherThanParent )
                          this.focus('previousBorn','radio_previousBornRadio_0').error_previousBirth = PREFIX + 'previousBirth.error_empty';
               }
               else 
               if ( this.parent.isPreviousBirth == 'Y' ) {

                   if (   /////!this.component.isCustodyOtherThanParent && 
                         this.parent.howManyLiveborn == 0 && 
                         this.parent.howManyStillborn ==  0 ) {
                         this.focus('previousBorn','radio_previousBornRadio_0').error_howManyLiveBorn  = PREFIX + 'previousBirth.error_totalBornZero';
                         this.focus('previousBorn','radio_previousBornRadio_0').error_howManyStillBorn = PREFIX + 'previousBirth.error_totalBornZero';
                         return;
                   }

                   if ( ////!this.component.isCustodyOtherThanParent  && 
                         Util.isEmptyNumber(this.parent.howManyLiveborn ) ) 
                        this.focus('previousBorn','input_liveBorn').error_howManyLiveBorn = PREFIX + 'previousBirth.error_howManyLiveborn_empty';
                   else
                   if ( this.parent.howManyLiveborn < 0 || this.parent.howManyLiveborn > 14 ) 
                        this.focus('previousBorn','input_liveBorn').error_howManyLiveBorn = PREFIX + 'previousBirth.error_howManyLiveborn_invalid';
                        
                   if ( ///!this.component.isCustodyOtherThanParent && 
                        Util.isEmptyNumber(this.parent.howManyStillborn ) ) 
                        this.focus('previousBorn','input_stillBorn').error_howManyStillBorn = PREFIX + 'previousBirth.error_howManyStillborn_empty';
                   else
                   if ( this.parent.howManyStillborn < 0 || this.parent.howManyStillborn > 9 ) 
                        this.focus('previousBorn','input_stillBorn').error_howManyStillBorn = PREFIX + 'previousBirth.error_howManyStillborn_invalid';
               }
       }

       private whenParenBornValidate() {

               let age:number = Util.age(this.parent.whenParentBorn);

               if ( age == null ) {  // empty
                    if ( !this.component.isCustodyOtherThanParent || !Util.isEmpty(this.parent.whenParentBorn) ) 
                          this.focus('whenParentBorn','select_date_whenParentBornBD').error_whenParentBorn = PREFIX + 'whenParentBorn.error_empty_birthParent$';
               }
               else 
               if ( age == Util.FUTURE_DATE ) 
                  this.focus('whenParentBorn','select_date_whenParentBornBD').error_whenParentBorn = PREFIX + 'whenParentBorn.error_future_birthParent$';
               else 
               if ( age == Util.INVALID_DATE ) 
                  this.focus('whenParentBorn','select_date_whenParentBornBD').error_whenParentBorn = PREFIX + 'whenParentBorn.error_invalid_birthParent$';                    
               else
               if ( age < 10 || age > 85 ) 
                  this.focus('whenParentBorn','select_date_whenParentBornBD').error_whenParentBorn = PREFIX + 'whenParentBorn.error_range_birthParent$';                    
       }

       private otherLastNameAtBirth() {

               if ( Util.isEmpty(this.parent.isOtherLastNameAtBirth)  ) {
                    if ( !this.component. isCustodyOtherThanParent || this.parent.isGiveBirth==Confirm.YES )
                          this.focus('lastNameAtBirth','radio_lastNameAtBirthRadio_0').error_lastNameAtBirth = PREFIX + 'atBirth.error_empty_single$';
               }
               else
               if ( this.parent.isOtherLastNameAtBirth == 'Y' ) {

                    if ( Util.isEmpty(this.parent.lastNameAtBirth ) ) {
                         ////if ( !this.component. isCustodyOtherThanParent || this.parent.isGiveBirth==Confirm.YES )
                         this.focus('lastNameAtBirth','input_lastNameAtBirthInput').error_birthNameInput = PREFIX + 'birthName.error_empty_single$';
                    }
                    else
                    if ( !Util.isValidName(this.parent.lastNameAtBirth ) ) 
                         this.focus('lastNameAtBirth','input_lastNameAtBirthInput').error_birthNameInput = PREFIX + 'birthName.error_invalid_single$';
               }
       }

       private otherPreviousNameUsed() {

               if ( Util.isEmpty(this.parent.isOtherPreviousName) ) {
                    if ( !this.component.isCustodyOtherThanParent || this.parent.isGiveBirth==Confirm.YES ) 
                          this.focus('otherLastName','radio_otherLastNameRadio_0').error_otherLastName = PREFIX + 'otherLastName.error_empty_single$';
               }
               else
               if ( this.parent.isOtherPreviousName == 'Y' ) {
                     
                    if ( Util.isEmpty(this.parent.previousLastName ) )  
                         ////if ( !this.component. isCustodyOtherThanParent || this.parent.isGiveBirth==Confirm.YES )
                         this.focus('otherLastName','input_otherLastNameInput').error_prevNameInput = PREFIX + 'previousName.error_empty_single$';
                    else
                    if ( !Util.isValidName(this.parent.previousLastName ) ) 
                         this.focus('otherLastName','input_otherLastNameInput').error_prevNameInput = PREFIX + 'previousName.error_invalid_single$';
               }
       }

       private cityValidate() {

               if ( Util.isEmpty(this.parent.placeOfBirth.city) )  {
                    if ( !this.component.isCustodyOtherThanParent )
                          this.focus('whereParentBorn','input_cityInput').error_city = PREFIX + 'city.error_empty_city$';
               }
               else
               if ( Util.hasSpecialCharacter(this.parent.placeOfBirth.city ) ) 
                    this.focus('whereParentBorn','input_cityInput').error_city = PREFIX + 'city.error_invalid_city$';
       }

       private provinceValidate() {

               if ( Util.isEmpty(this.parent.placeOfBirth.province) ) {
                    if ( !this.component.isCustodyOtherThanParent )
                          this.focus('whereParentBorn','select_provinceSelect').error_province = PREFIX + 'province.error_empty_province$';
               }
               else 
               if ( Country.CANADA  != this.parent.placeOfBirth.country ) {
                     if ( this.parent.placeOfBirth.country != "" && 
                          Code.NotApplicable != this.parent.placeOfBirth.province )  
                          this.focus('whereParentBorn','select_provinceSelect').error_province = PREFIX + 'province.error_invalid_province$';
               } 
               else 
               if ( Code.NotApplicable == this.parent.placeOfBirth.province )  
                          this.focus('whereParentBorn','select_provinceSelect').error_province = PREFIX + 'province.error_invalid_province$';
       }

       private countryValidate() {
               if ( !this.component.isCustodyOtherThanParent && Util.isEmpty(this.parent.placeOfBirth.country) ) 
                    this.focus('whereParentBorn','select_countrySelect').error_country = PREFIX + 'country.error_empty_birthParent$';
       }

       private otherCountryValidate() {

               if ( this.component.isCustodyOtherThanParent ) return;

               if ( Util.isEmpty(this.parent.placeOfBirth.otherCountry) ) {
                    if ( this.component.parentIndex == 0 )
                         this.focus('whereParentBorn','input_otherCountry').error_otherCountry = PREFIX + 'otherCountry.error_empty_otherCountry$';
                    else this.focus('whereParentBorn','input_otherCountry').error_otherCountry = PREFIX + 'otherCountry.error_empty_otherCountry2N';
               }
               else
               if ( Util.hasSpecialCharacter(this.parent.placeOfBirth.otherCountry ) )  {
                  if ( this.component.parentIndex == 0 )
                       this.focus('whereParentBorn','input_otherCountry').error_otherCountry = PREFIX + 'otherCountry.error_invalid_otherCountry$';
                  else
                       this.focus('whereParentBorn','input_otherCountry').error_otherCountry = PREFIX + 'otherCountry.error_invalid_otherCountry2N';
               }
                    
       }
              
       private jump(tagId:string) : AboutTheParentsScreenComponent {
               if ( this.success )
                    this.viewportScroller.scrollToAnchor(tagId);
               this.success = false;
               return this.component;
       }

       private focus(tagId:string,ctrlId:string) : AboutTheParentsScreenComponent {
            if ( this.success ) {
                 this.viewportScroller.scrollToAnchor(tagId);
                 let ctrl = document.getElementById(ctrlId);
                 if ( ctrl ) ctrl.focus();
            }
                 
            this.success = false;
            return this.component;
       }

       public IdOfChanged():number { 

            if (  this.parent.parentType      !=  this.inputParent.parentType ||
                  this.parent.whenParentBorn  !=  this.inputParent.whenParentBorn ||
                  this.parent.lastNameAtBirth !=  this.inputParent.lastNameAtBirth ||
                  this.parent.previousLastName!=  this.inputParent.previousLastName ||

                  this.parent.isOtherLastNameAtBirth !=  this.inputParent.isOtherLastNameAtBirth ||
                  this.parent.isOtherPreviousName    !=  this.inputParent.isOtherPreviousName ||
                  
                  this.parent.placeOfBirth.city     !=  this.inputParent.placeOfBirth.city ||
                  this.parent.placeOfBirth.province !=  this.inputParent.placeOfBirth.province ||
                  this.parent.placeOfBirth.country  !=  this.inputParent.placeOfBirth.country ||
                  this.parent.placeOfBirth.otherCountry !=  this.inputParent.placeOfBirth.otherCountry ) return this.menuID;


             if ( this.component.isBirthParent || this.component.isSurrogate && this.component.parentIndex == 0  ) {
                  if ( this.parent.maritalStatus !=  this.inputParent.maritalStatus ) return this.menuID;
             }

             if ( this.component.isBirthParent == true ) {
                  if (  this.parent.isPreviousBirth   !=  this.inputParent.isPreviousBirth ||
                        this.parent.pregnancyDuration !=  this.inputParent.pregnancyDuration ||
                        this.parent.howManyLiveborn   !=  this.inputParent.howManyLiveborn ||
                        this.parent.howManyStillborn  !=  this.inputParent.howManyStillborn ) return this.menuID;
             }
             
             return 0;
       }
}
